export enum BookingStatusEnum{
	pendingApproval = 'PendingApproval',
	paymentNeeded = 'PaymentNeeded',
	inReview = 'InReview',
	approved = 'Approved',
	canceled = 'Canceled',
	denied = 'Denied',
	completed = 'Completed'
}

export const BookingStatusDisplayNames = {
	[BookingStatusEnum.pendingApproval]: 'Pending Approval',
	[BookingStatusEnum.paymentNeeded]: 'Payment Needed',
	[BookingStatusEnum.inReview]: 'In Review',
	[BookingStatusEnum.approved]: 'Approved',
	[BookingStatusEnum.canceled]: 'Canceled',
	[BookingStatusEnum.denied]: 'Denied',
	[BookingStatusEnum.completed]: 'Completed'
};